/*
 * Madison Maison - CCPA/CPRA + GPC privacy controls
 * Added 2026-05-22 in response to Velandia demand letter.
 *
 * Uses Shopify Customer Privacy API:
 *   https://shopify.dev/docs/api/customer-privacy
 *
 * Behavior:
 *  - Honors Global Privacy Control (navigator.globalPrivacyControl) automatically.
 *  - "Do Not Sell or Share" link opens a confirmation, then sets analytics_allowed
 *    and marketing_allowed and sale_of_data_allowed to false.
 *  - Shows a consent banner on first visit if regulation requires it.
 */
(function () {
  'use strict';

  function loadPrivacyApi(cb) {
    if (window.Shopify && window.Shopify.customerPrivacy) { cb(); return; }
    document.addEventListener('visitorConsentCollected', cb, { once: true });
    var s = document.createElement('script');
    s.src = 'https://cdn.shopify.com/shopifycloud/consent-tracking-api/v0.1/consent-tracking-api.js';
    s.async = true;
    s.onload = cb;
    document.head.appendChild(s);
  }

  // 1. Honor Global Privacy Control automatically.
  function honorGPC() {
    if (navigator.globalPrivacyControl !== true) return;
    if (!window.Shopify || !window.Shopify.customerPrivacy) return;
    try {
      window.Shopify.customerPrivacy.setTrackingConsent({
        analytics: false,
        marketing: false,
        preferences: false,
        sale_of_data: false
      }, function () {});
    } catch (e) { /* no-op */ }
  }

  // 2. "Do Not Sell" link handler — opt the visitor out, show a simple confirmation.
  function wireDoNotSellLink() {
    var link = document.getElementById('OpenCCPAModal');
    if (!link) return;
    link.addEventListener('click', function (e) {
      e.preventDefault();
      if (!window.Shopify || !window.Shopify.customerPrivacy) {
        alert('Privacy controls are loading. Please try again in a moment.');
        return;
      }
      try {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: false,
          marketing: false,
          preferences: false,
          sale_of_data: false
        }, function (ok) {
          alert(ok
            ? 'Your preference has been recorded. We will not sell or share your personal information.'
            : 'There was a problem recording your preference. Please refresh and try again.');
        });
      } catch (e) {
        alert('There was a problem recording your preference. Please refresh and try again.');
      }
    });
  }

  // 3. Banner-driven consent flow.
  var CONSENT_COOKIE = 'mm_consent_v1';
  function readConsentCookie() {
    var match = document.cookie.match(/(?:^|;\s*)mm_consent_v1=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }
  function writeConsentCookie(value) {
    var oneYear = 60 * 60 * 24 * 365;
    document.cookie = CONSENT_COOKIE + '=' + encodeURIComponent(value) + '; path=/; max-age=' + oneYear + '; SameSite=Lax; Secure';
  }

  function applyConsent(accepted) {
    if (!window.Shopify || !window.Shopify.customerPrivacy) return;
    var allow = accepted === true;
    try {
      window.Shopify.customerPrivacy.setTrackingConsent({
        analytics: allow,
        marketing: allow,
        preferences: allow,
        sale_of_data: allow
      }, function () {});
    } catch (e) { /* no-op */ }
  }

  function showBanner() {
    var banner = document.getElementById('MadisonConsentBanner');
    if (!banner) return;
    banner.hidden = false;
    var accept = document.getElementById('MadisonConsentAccept');
    var reject = document.getElementById('MadisonConsentReject');
    var optOut = document.getElementById('MadisonConsentOptOutLink');
    function hide(choice) {
      writeConsentCookie(choice);
      banner.hidden = true;
      applyConsent(choice === 'accept');
    }
    if (accept) accept.addEventListener('click', function () { hide('accept'); });
    if (reject) reject.addEventListener('click', function () { hide('reject'); });
    if (optOut) optOut.addEventListener('click', function (e) {
      e.preventDefault();
      hide('reject');
    });
  }

  function initBanner() {
    // If GPC is on, treat as a permanent reject — never show the banner.
    if (navigator.globalPrivacyControl === true) {
      writeConsentCookie('gpc-reject');
      applyConsent(false);
      return;
    }
    var existing = readConsentCookie();
    if (existing) {
      applyConsent(existing === 'accept');
      return;
    }
    // Default to deny until interaction.
    applyConsent(false);
    showBanner();
  }

  loadPrivacyApi(function () {
    honorGPC();
    wireDoNotSellLink();
    initBanner();
  });
})();
